module.exports = __webpack_public_path__ + "img/service-icon3.40d63b03.png";